import { dictionary, enhanceMessages } from '../utils/i18n'

import messagesTree from './locale/dictionary'

const messages = enhanceMessages<typeof messagesTree>(messagesTree)

export default messages

export const cs = dictionary
